import { render } from "./CircleOfLife.vue?vue&type=template&id=36684174&scoped=true"
import script from "./CircleOfLife.vue?vue&type=script&lang=js"
export * from "./CircleOfLife.vue?vue&type=script&lang=js"

import "./CircleOfLife.vue?vue&type=style&index=0&id=36684174&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36684174"]])

export default __exports__